import { amplitudeSendEvent, getScreenName } from '@musinsa/frontend-utils';
import { Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { getPaths } from '../../common';
import { useNavigate } from '../../common/hooks/useNavigate';
import { curatorQueries } from '../../query-factory';

interface Props {
  className?: string;
  curationId: string;
  /** 마이 큐레이션 타입 — SNAP2일 때 스냅 수정 문구 */
  curationType?: 'GOODS' | 'SNAP2' | null;
}

export const CurationEditButton = ({ className, curationId, curationType }: Props) => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  const paths = getPaths(service);
  const { data: userInfo } = useQuery({ ...curatorQueries.profile.userInfo });

  const onClick = (id: string) => {
    if (service === SERVICE.MUSINSA) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'curation_edit_try',
        component_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        id: userInfo?.snsTitle ?? '',
        section_name: 'curator_curationfeed',
        type: curationType === 'SNAP2' ? 'snap' : 'goods',
      });
    }
    navigate(paths.editCuration({ curationId: id }));
  };

  return (
    <Typography
      className={twMerge('py-[12px]! space-y-[11px] cursor-pointer', className)}
      colorScheme="gray-600"
      variant="body13pxReg"
      onClick={() => onClick(curationId)}
    >
      {curationType === 'SNAP2' ? '제목 및 스냅 수정' : '제목 및 상품 수정'}
    </Typography>
  );
};
